import { render } from "./RatView.vue?vue&type=template&id=288ed566&scoped=true"
import script from "./RatView.vue?vue&type=script&lang=js"
export * from "./RatView.vue?vue&type=script&lang=js"

import "./RatView.vue?vue&type=style&index=0&id=288ed566&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-288ed566"]])

export default __exports__